import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BackdropWithLoader from '../../../../../Tools/BackdropWithLoader/BackdropWithLoader';
import ModalWithLoader from '../../../../../Tools/ModalWithLoader/ModalWithLoader';
import { PdsImportState } from './usePdsImport';

type ImportFeedbackProps = {
  importState: PdsImportState;
};

/**
 * Progression et erreur d'un import. Le bilan de succès, lui, est rendu par
 * `ImportReportBanner` au-dessus de la table : il n'a pas à être répété en modale.
 */
export default function ImportFeedback({ importState }: ImportFeedbackProps) {
  const { t } = useTranslation();

  return (
    <>
      <BackdropWithLoader
        open={importState.isImporting}
        message={t('interventionCreation.addServicePoints.importing')}
      />

      <ModalWithLoader
        openModal={importState.hasFailed}
        status={importState.hasFailed ? 'error' : null}
        customErrorMessage={
          <Stack spacing={1} alignItems="center">
            <Typography variant="body2" fontWeight={500}>
              {t('interventionCreation.addServicePoints.importError')}
            </Typography>
            {importState.failureReason !== null && (
              <Typography variant="body2" color="text.secondary" textAlign="center">
                {importState.failureReason}
              </Typography>
            )}
          </Stack>
        }
        onClose={importState.dismissError}
      />
    </>
  );
}
